import React from 'react';
import {Grid} from '@mui/material';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';
import Card from '@mui/material/Card';

export default function TransferEntryTwoUpdate({code}) {
  const {values} = useFormikContext();
  return (
    <Card className={'box-shadow'} sx={{p: 4, pb: 5}}>
      <Grid container spacing={1.5}>
        {values?.dimensions?.map((item, index) => {
          return (
            <Grid item sm={6} xs={12}>
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={item?.name}
                     name={`dimensions.${index}.value`} disabled
                     InputLabelProps={{
                       style: {fontSize: 14, color: '#929191'},
                       shrink: true,
                       marginDense: false
                     }}/>
            </Grid>
          )
        })}
      </Grid>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Dyes'}
             disabled
             name={`translations.${code}.dyes`} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Motifs'} disabled
             name={`motifs`} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Description'}
             multiline rows={5} disabled
             name={`description`} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}